import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/site";

export default function WhatsAppFloat() {
  const href = `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(BRAND.whatsappMessage)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping-slow" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform">
        <MessageCircle size={26} />
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black border border-white/10 px-3 py-2 text-[11px] uppercase tracking-[0.25em] text-white opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
        Chat on WhatsApp
      </span>
    </a>
  );
}
